import React, { useEffect, useState } from "react";
import { Form, Formik, Field } from "formik";
import { Link } from 'react-router-dom';
import RadioButton from 'web/components/form-elements/RadioButton';
import Button from "web/components/Button";
import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from "web/components/utils/onHoldModalUtils";

import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import "./alert.scss";
import styled from "styled-components";
export default ({
  isOpen,
  toggle,
  title,
  content,
  link,
  response,
  onHoldCallBack,
  orderRetryPayment
}) => {

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const redirectLink = (link) => {
    toggle(!isOpen);
  };

  const [paymentMethodId, setPaymentMethodId] = useState();

  useEffect(() => {

  }, [])

  const creditDetailFields = () => {
    const cardDetailsArr = [];
    if (response.forBuying && response.forBuying.debitCards.length !== 0) {
      for (let i = 0; i < response.forBuying.debitCards.length; i++) {
        let name = '';
        let cardName = response.forBuying.debitCards[i].card.brand
        if (response.forBuying.debitCards[i].name) {
          name = response.forBuying.debitCards[i].name + ' - '
        }
        let cardDetailsObj =
          {
            value: response.forBuying.debitCards[i].id,
            label: name + '' + (cardName.charAt(0).toUpperCase() + cardName.slice(1)) +
              ' ending in ' + response.forBuying.debitCards[i].card.last4Digit + ', expires ' + response.forBuying.debitCards[i].card.expMonth + '/' + response.forBuying.debitCards[i].card.expYear,
          }

        cardDetailsArr.push(cardDetailsObj)


        if (i === response.forBuying.debitCards.length - 1) {
          if (response?.forBuying && response?.forBuying?.achAccounts && response?.forBuying?.achAccounts.length !== 0) {
            for (let i = 0; i < response?.forBuying?.achAccounts.length; i++) {

              let cardDetailsObj =
                {
                  value: response?.forBuying?.achAccounts[i].id,
                label: 'Account Number: ******' + response?.forBuying?.achAccounts[i].achBankAccount.last4 + '   Bank Routing Number: ******' + response.forBuying.achAccounts[
                    i
                  ].achBankAccount.routingNumber.slice(
                    response?.forBuying?.achAccounts[i].achBankAccount
                      .routingNumber.length - 4
                  ),
                  type: 'achPay'
                }

              if (orderRetryPayment !== 'Exclude_Ach') cardDetailsArr.push(cardDetailsObj)

              if (i === response?.forBuying?.achAccounts.length - 1) {
                return <>
                  {cardDetailsArr &&
                    cardDetailsArr.map((value, index) => (
                      <NewPayment className="row">
                        <div className="col-12">
                          <div key={index}>
                            <Field
                              component={RadioButton}
                              name='cardTypeRadio'
                              className="radio-label"
                              id={value.value}
                              defaultValue={cardDetailsArr[0].value}
                              onSelect={(e) => { setPaymentMethodId(e.target.value) }}
                              label={value.label}
                            />
                          </div>
                        </div>
                      </NewPayment>
                    ))}
                </>
              }
            }
          } else {
            return <>
              {cardDetailsArr &&
                cardDetailsArr.map((value, index) => (
                  <NewPayment className="row">
                    <div className="col-12">
                      <div key={index}>
                        <Field
                          component={RadioButton}
                          name='cardTypeRadio'
                          className="radio-label"
                          id={value.value}
                          defaultValue={cardDetailsArr[0].value}
                          onSelect={(e) => { setPaymentMethodId(e.target.value) }}
                          label={value.label}
                        />
                      </div>
                    </div>
                  </NewPayment>
                ))}
            </>
          }

        }
      }
    }
    if (response?.forBuying && response?.forBuying?.debitCards.length === 0 && response?.forBuying && response?.forBuying?.achAccounts && response?.forBuying?.achAccounts.length !== 0) {
      if (response?.forBuying && response?.forBuying?.achAccounts && response?.forBuying?.achAccounts.length !== 0) {
        for (let i = 0; i < response?.forBuying?.achAccounts.length; i++) {

          let cardDetailsObj =
            {
              value: response?.forBuying?.achAccounts[i].id,
            label: 'Account Numebr: ******' + response?.forBuying?.achAccounts[i].achBankAccount.last4 + '   Bank Routing Number: ******' + response?.forBuying?.achAccounts[
                i
              ].achBankAccount.routingNumber.slice(
                response?.forBuying?.achAccounts[i].achBankAccount
                  .routingNumber.length - 4
              ),
              type: 'achPay'
            }

          if (orderRetryPayment !== 'Exclude_Ach') cardDetailsArr.push(cardDetailsObj)

          if (i === response?.forBuying?.achAccounts.length - 1) {
            return <>
              {cardDetailsArr &&
                cardDetailsArr.map((value, index) => (
                  <NewPayment className="row">
                    <div className="col-12">
                      <div key={index}>
                        <Field
                          component={RadioButton}
                          name='cardTypeRadio'
                          className="radio-label"
                          id={value.value}
                          defaultValue={cardDetailsArr[0].value}
                          onSelect={(e) => { setPaymentMethodId(e.target.value) }}
                          label={value.label}
                        />
                      </div>
                    </div>
                  </NewPayment>
                ))}
            </>
          }
        }
      }
    }
    else {
      return <div className="row">
        <div className="col-12">
          <p>Payment method is missing.</p>
        </div>
      </div>
    }
  }
  return (
    <>
      <div className="alert-modal">
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          backdrop={"static"}
          centered={true}
          className="acknowledgeModal"
        >
          <div>
            <div className="header">
              <Button
                handleClick={() => {
                  redirectLink(link);
                }}
              >
                <img src={CloseIcon} className="closeIcon" alt="close-icon" />
              </Button>
              <h3>Pay With</h3>
            </div>
            <ModalBody>
              <div className="modal-content">
                <Formik
                  initialValues={INITIAL_VALUES}
                  validationSchema={VALIDATION_SCHEMA()}
                  onSubmit={(values) => { }}
                >
                  {(props) => {
                    const { isValid, dirty, values, errors, touched } = props;
                    return (
                      <>
                        <Form>
                          <PayWith>
                            <AccountSection>
                              <AccountType>
                                {response && creditDetailFields()}
                              </AccountType>
                            </AccountSection>
                            <AccountDetail></AccountDetail>
                          </PayWith>
                          <Button
                            type="app-green-button submitBtn"
                            disabled={paymentMethodId ? false : true}
                            handleClick={() => {
                              onHoldCallBack(paymentMethodId)
                            }}
                          >
                            Submit
                          </Button>
                          <p>
                            To add new payment information.&nbsp;
                              <Link to="/manage-account?pageType=manageAccount" style={{ 'color': '#007bff' }}>
                              Click Here
                              </Link>
                          </p>
                        </Form>
                      </>
                    );
                  }}
                </Formik>
              </div>
            </ModalBody>
            <ModalFooter className="modal-footer"></ModalFooter>
          </div>
        </Modal>
      </div>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        alertType=''
        callBackAlert={(val) => {
        }}
        content=''
        link='/'
      />
    </>
  );
};

const TermText = styled.div`
  overflow: auto;
  height: calc(100vh - 426px);
  text-align: left;
  border: 2px solid #ccc;
    margin: 25px 0;
    padding: 10px;
  p {
    margin: 0 0 20px;
  }
  .checkbox-field {
    margin-top: 50px;
  }
`;
const PayWith = styled.div`
  
`;
const Heading = styled.div`
  font-size: 20px;
  color: #000000;
  line-height: 25px;
  font-family: 'latobold';
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
const AccountSection = styled.div`
  display: flex;
  border: 1px solid #e0e0e0;
  padding: 10px 15px;
  max-height: 400px;
  overflow: auto;
`;
const AccountType = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  > div {
    > div {
      display: flex;
      > div {
        flex: 1;
        &:first-child {

          > div > div > div > div {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            > div {
              min-height: 40px;
              display: flex;
              align-items: center;
              .radio-label {
                color: black !important;
                margin: 0;
              }
            }
          }
        }
        &:nth-child(2) {
          max-width: 400px;
          padding-left: 38px;
          > div > div {
            .radio-label {
            }           
          }
          .payment {
            label {
              font-size: 16px;
              color: #212529;
              letter-spacing: normal;
              .StripeElement,
              input {
                border: solid 1px #dddddd;
              }
            }
            Button {
              height: 36px;
            }
          }
        }
      }
      @media only screen and (max-width: 725px) {
        flex-direction: column;
        > div {
          flex: 1;
          &:first-child {
            max-width: 100%;
            border: none;
            > div > div > div > div {
              flex-direction: row;
            }
          }
          &:nth-child(2) {
            max-width: 100%;
            padding-left: 0;
          }
        }
      }
    }
  }
 
`;
const AccountDetail = styled.div``;
const NewPayment = styled.div`
    > div {
        border-right: none !important;
    }
    .radio-label {
        color: #000 !important;
        margin-bottom: 0;
    }
    .radioField {
        height: 60px !important;
        display: flex;
    align-items: center;
    }
`
